import React from "react";
import { Box, Button, Stack } from "@mui/material";

interface AssessmentNavigationProps {
  disableNext: boolean;
  isFinalStep: boolean;
  onBack: () => void;
  onNext: () => void;
  finalLabel?: string;
}

export const AssessmentNavigation: React.FC<AssessmentNavigationProps> = ({
  disableNext,
  isFinalStep,
  onBack,
  onNext,
  finalLabel,
}) => (
  <Box
    display="flex"
    flexDirection={{ xs: "column", sm: "row" }}
    justifyContent={{ xs: "stretch", sm: "space-between" }}
    alignItems="center"
    gap={2}
    sx={{ width: "100%" }}
  >
    <Button
      variant="outlined"
      onClick={onBack}
      sx={{ order: { xs: 1, sm: 0 } }}
      fullWidth
    >
      Back
    </Button>
    <Button
      variant="contained"
      onClick={onNext}
      disabled={disableNext}
      sx={{ order: { xs: 0, sm: 1 } }}
      fullWidth
    >
      {isFinalStep ? finalLabel ?? "Finish" : "Continue"}
    </Button>
  </Box>
);
